export default __webpack_public_path__ + "static/media/logo.2e9a0ee1.png";